<div class="custom-shipping-day">
  <pdq-card color="white">
    <div class="dialog-header">
      <div class="dialog-header-content">Closed days</div>
    </div>
    <p style="padding: 0 20px 8px 20px">Define days that won’t count as “business days” in delivery promise</p>

    <div class="content">
      <pdq-dropdown
        class="dropdown"
        mode="tight-ghost"
        [border]="true"
        [defaultOption]="selectedCategory || closedDaysOption[0]"
        [options]="closedDaysOption"
        buttonFontSize="16"
        (onChange)="onCategoryChange($event)">
      </pdq-dropdown>
      @if (selectedCategory?.value === 'holidays') {
        <div class="holidays-dropdown">
          <pdq-dropdown
            class="dropdown"
            mode="tight-ghost"
            [border]="true"
            [defaultOption]="selectedHolidayRegion || holidayRegions[0]"
            [options]="holidayRegions"
            buttonFontSize="16"
            (onChange)="onHolidayRegionChange($event)">
          </pdq-dropdown>

          <pdq-dropdown
            *ngIf="selectedHolidayRegion?.value"
            class="dropdown"
            mode="tight-ghost"
            [border]="true"
            [disabled]="isNationalHolidaysLoading"
            [defaultOption]="selectedNationalHolidays || nationalHolidays[0]"
            [options]="nationalHolidays"
            placeholder="Select holidays"
            [multiSelect]="true"
            selectBy="checked"
            buttonFontSize="16"
            [showSelectUnselectOptions]="true"
            [multiSelectCountFormatter]="formatSelectedHolidaysCount"
            (onMultiSelectChange)="onNationalHolidaysSelectionReplaced($event)">
          </pdq-dropdown>
        </div>
      }
      @if (selectedCategory?.value === 'daysOfTheWeek') {
        <pdq-dropdown
          class="dropdown"
          mode="tight-ghost"
          [border]="true"
          [defaultOption]="selectedDaysOfTheWeek || daysOfTheWeek[0]"
          placeholder="select days of the week"
          [options]="daysOfTheWeek"
          [multiSelect]="true"
          selectBy="checked"
          buttonFontSize="16"
          [showSelectUnselectOptions]="true"
          [multiSelectCountFormatter]="formatSelectedDaysCount"
          (onMultiSelectChange)="onDaysOfTheWeekSelectionReplaced($event)">
        </pdq-dropdown>
      }
      @if (selectedCategory?.value === 'customDays') {
        <div>
          <pdq-date-range-picker
            (onApply)="handleDateRangeChange($event)"
            [showPresets]="false"
            [minDate]="0"></pdq-date-range-picker>
        </div>
      }
      <pdq-button
        (onClick)="addSelection()"
        label="+ Add"
        variant="primary"
        [disabled]="!isInsertAllFields()"></pdq-button>
    </div>

    <div class="custom-divier"></div>
    <div style="display: flex; flex-flow: column; gap: 8px; padding: 10px 20px 0">
      @for (selection of selections; track selection; let i = $index) {
        @if (selection?.data?.type === 'holidays') {
          <div style="display: flex; flex-flow: row; gap: 8px">
            <div class="custom-box" style="width: 260px">
              {{ getClosedDayTypeLabel(selection.data.type) }}
            </div>
            <div class="custom-box" style="width: 260px">
              {{ getHolidayRegionLabels(selection) }}
            </div>
            <div class="custom-box" style="width: 260px" [title]="getNationalHolidayLabels(selection)">
              {{ getNationalHolidayLabels(selection) }}
            </div>
            <pdq-button
              (onClick)="onDeleteSelection(selection)"
              iconColor="var(--on-surface-light)"
              variant="ghost"
              icon="close"></pdq-button>
          </div>
        }
        @if (selection?.data?.type === 'daysOfTheWeek') {
          <div style="display: flex; flex-flow: row; gap: 8px">
            <div class="custom-box" style="width: 260px">
              {{ getClosedDayTypeLabel(selection.data.type) }}
            </div>
            <div class="custom-box" style="width: 260px" [title]="getDaysOfTheWeekLabels(selection)">
              {{ getDaysOfTheWeekLabels(selection) }}
            </div>
            <pdq-button
              (onClick)="onDeleteSelection(selection)"
              iconColor="var(--on-surface-light)"
              variant="ghost"
              icon="close"></pdq-button>
          </div>
        }
        @if (selection?.data?.type === 'customDays') {
          <div style="display: flex; flex-flow: row; gap: 8px">
            <div class="custom-box" style="width: 260px">
              {{ getClosedDayTypeLabel(selection.data.type) }}
            </div>
            <div class="custom-box" style="width: 260px">
              {{ selection.data.customDate?.startDate | date }} - {{ selection.data.customDate?.endDate | date }}
            </div>
            <pdq-button
              (onClick)="onDeleteSelection(selection)"
              iconColor="var(--on-surface-light)"
              variant="ghost"
              icon="close"></pdq-button>
          </div>
        }
      }
    </div>
    <div class="buttons">
      <div>
        <pdq-button [disabled]="isLoading" label="Save" variant="primary" (onClick)="saveSelections()"></pdq-button>
      </div>
    </div>
  </pdq-card>
</div>
